<template>
    <nav class="HeaderMobileNav hide--reciteme-and-up">
        <a
            href="/search"
            class="HeaderMobileNav__search"
        >
            <BaseIcon
                icon="search-icon"
            />
        </a>
        <NavToggle
            @toggle="toggle"
        />
    </nav>
</template>
<script>
export default {
    name: 'HeaderMobileNav',
    methods: {
        toggle(toggle) {
            this.$emit('toggle', toggle)
        }
    }
}
</script>
<style lang="scss">
    .HeaderMobileNav a {
        display: inline-block;
        padding: getSpacing('spacer');
        border-left: 1px solid $border-color;
        font-size: 1.25rem;

        @include media-query(hide--reciteme-and-up) {
            display: none;
        }
    }

    .HeaderMobileNav .BaseIcon {
        color: $action-color;
    }
</style>
